import { Editor } from "@tinymce/tinymce-react";

export const CustomCkeditor = ({
  value = "",
  name = "",
  height = 300,
  onChange = () => {},
  onBlur = () => {},
}) => {
  return (
    <div className="">
      <Editor
        apiKey="r0lzzen2x5emjrsroqynzso0o4yegpv31f58ufzvao07o2pl"
        init={{
          height: height,
          statusbar: false,
          menubar: "file edit view insert format tools table help",
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "code",
            "help",
            "wordcount",
          ],
          style_formats: {
            link: { block: "a", classes: "underline" },
          },
          directionality: "ltr",
          toolbar:
            "undo redo | blocks | " +
            "bold italic forecolor | link | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help ",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          quickbars_selection_toolbar:
            "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
          noneditable_noneditable_class: "mceNonEditable",
          toolbar_drawer: "sliding",
          spellchecker_dialog: true,
        }}
        value={value}
        onEditorChange={(newValue, editor) => {
          onChange({ target: { name: name, value: editor.getContent() } });
        }}
      />
    </div>
  );
};
